import { Component, Q } from '@fullstory/tomato';
import { MaskerView } from '@fullstory/tomato-views/views';
import { ElemBounds } from './rectangles';

export class Masker extends Component<MaskerView> {
  // To guard against async style setting racing with hiding and showing.
  private _pendingHide: number;
  constructor(v: MaskerView) {
    super(v);
  }

  highlight(elems: ElemBounds[]) {
    if (this._pendingHide != null) {
      clearTimeout(this._pendingHide);
      this._pendingHide = null;
    }

    this.clear();

    const mask = this.mask();
    elems.forEach(elem => {
      elem.allRects().forEach(r => {
        const maskRect = Q.createOne('rect')
          .addClass('maskrect')
          .setAttr('x', `${r.left}`)
          .setAttr('y', `${r.top}`)
          .setAttr('width', `${r.width}`)
          .setAttr('height', `${r.height}`);
        maskRect.setAttr('data-selector', elem.selector());
        mask.append(maskRect);
      });
    });

    // Workaround for Chrome SVG bug. Some SVG things don't render if you use JS apis to build it. So tickle the HTML parser.
    setTimeout(() => {
      this.view().setHtml(this.view().html());
    });
    this.show();
  }

  clear() {
    Q.selectMany('.maskrect').remove();
  }

  mask(): Q.OfOne {
    // NOTE: We lose this reference because of the innerHTML we do to work around the Chrome SVG bug.
    return new Q.OfOne(document.getElementById('mask'));
  }

  show() {
    this.view().setCss('display', 'block');
  }

  hide() {
    if (this._pendingHide) {
      return;
    }
    this._pendingHide = window.setTimeout(() => {
      this.clear();
      this.view().setCss('display', 'none');
      this._pendingHide = null;
    }, 300);
  }
}
